import { EmptyState, FlexColumn, Loading } from '@gorila-shared-ui/components';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { useStyles } from '../../../hooks/useStyles';
import { getHistoricDoorStateByGroup } from '../../../services/reportsService';
import { apiParamsState, isAllWorkspacesSelect } from '../../../storage/app';
import {
  loadingDoorState,
  reportDoorState,
  reportDoorStates,
  reportEndDateState,
  reportFilterGroupState,
  reportStartDateState,
} from '../../../storage/reports';
import { HistoricDoorState } from '../../../types/currentState';
import DoorStateReportTable from './DoorStateReportTable';

function DoorStateReportsByGroup() {
  const { css } = useStyles();
  const groupId = useRecoilValue(reportFilterGroupState);
  const endDate = useRecoilValue(reportEndDateState);
  const startDate = useRecoilValue(reportStartDateState);
  const apiParams = useRecoilValue(apiParamsState);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const [isLoadingDoorState, setIsLoadingDoorState] = useRecoilState(loadingDoorState);
  const setReportHistorics = useSetRecoilState(reportDoorStates);
  const resetDoorHistorics = useResetRecoilState(reportDoorStates);
  const states = useRecoilValue(reportDoorState(groupId));

  useEffect(() => {
    return () => {
      resetDoorHistorics();
    };
  }, []);

  useEffect(() => {
    if (!groupId || !startDate || !endDate || !apiParams) return;

    const loadHistoricDoor = async () => {
      setIsLoadingDoorState(true);
      const { historicDoor, error } = await getHistoricDoorStateByGroup(
        apiParams.clientId,
        groupId,
        startDate,
        endDate,
        isAllWorkspacesSelected ? undefined : apiParams.subClientId
      );
      const newHistorics: { [key: string]: HistoricDoorState[] } = {};
      if (!error) {
        newHistorics[groupId] = historicDoor ?? [];
      }
      setReportHistorics(newHistorics);
      setIsLoadingDoorState(false);
    };

    loadHistoricDoor();
  }, [groupId, startDate, endDate]);

  if (isLoadingDoorState) {
    return <Loading />;
  }

  if (!groupId) {
    return <EmptyState title="Selecciona un grupo para visualizar el reporte." />;
  }

  return (
    <FlexColumn
      gap={0}
      classNames={css({ flex: 1, overflow: 'hidden' })}
    >
      <DoorStateReportTable
        states={states}
        extended
      />
    </FlexColumn>
  );
}

export default DoorStateReportsByGroup;
